import { render, staticRenderFns } from "./commonHead.vue?vue&type=template&id=5a37767f&"
import script from "./commonHead.vue?vue&type=script&lang=js&"
export * from "./commonHead.vue?vue&type=script&lang=js&"
import style0 from "./commonHead.vue?vue&type=style&index=0&id=5a37767f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports